<template>

  <div class="row mt-2 card">
      <div class="card-body">
    <div class="col-12 ">

      <div class="form-group">
        <label for="exampleFormControlInput1">Nome</label>
        <input type="text" class="form-control col-12" v-model="regiao.nome" placeholder="">
      </div>
      <div class="form-group">
        <label for="exampleFormControlInput1">Valor mínimo para entrega</label>
        <input type="text" class="form-control col-12" v-model="regiao.valorMinimo" placeholder="">
      </div>
      <div class="form-group">
      <label for="exampleFormControlInput1">Observação</label>
        <input type="text" class="form-control col-12" v-model="regiao.obs" placeholder="">
      </div>

    </div>
    <div class="col-12">
      <button  v-if="item.nome != regiao.nome || item.valorMinimo != regiao.valorMinimo ||  item.obs != regiao.obs"  class='btn btn-primary' @click="$store.dispatch('updateRegiao',regiao)"> Salvar
      </button>
      <button class='btn' style="float:right" @click="$store.dispatch('removeRegiao',item)">
        <Trash2Icon /> </button>
    </div>
    </div>

  </div>

</template>


<script>
import {  Trash2Icon } from 'vue-feather-icons'
export default {
    components: {Trash2Icon},
    props:['item'],

    data(){
        return { 
            regiao:{...this.item}
        }
    }


}

</script>

<style>
</style>